import './styles/App.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Main from './game/Main';
import Loader from './loader';
import HistoryRoomAdmin from './game/components/HistoryAdmin';
import Maintenance from './game/components/Maintenance/Maintenance';

const App = ({ changeLanguage }) => {
    const { lang, isAdmin } = useSelector(state => state.user);
    const { isActive: isActiveLoader, msg } = useSelector(state => state.lobby.loader);
    const maintenance = useSelector(state => state.lobby.maintenance);

    useEffect(() => {
        if (lang) changeLanguage(lang);
    }, [lang, changeLanguage]);

    if (maintenance.includes('Game')) return <Maintenance activePage={'Game'}/>;
    if (isAdmin) return <HistoryRoomAdmin />;
    if (isActiveLoader) return <Loader msg={msg} />;

    return <Main />;
};

export default App;
